import type { ViewMode } from '@/hooks/useViewMode';

interface ItemListLoadingProps {
  amount: number;
  mode?: ViewMode;
}

export default function ItemListLoading({ amount, mode = 'list' }: ItemListLoadingProps) {
  if (mode === 'grid') {
    return (
      <div className="py-4">
        <ul className="m-0 grid list-none gap-4 p-0 grid-cols-[repeat(auto-fill,minmax(200px,1fr))]">
          {Array.from({ length: amount }, (_, i) => (
            <li key={i} className="rounded-xl border border-border/60 bg-card overflow-hidden">
              <div className="aspect-[4/3] animate-pulse bg-accent" />
              <div className="flex items-center gap-2 px-3 py-2.5">
                <div className="h-4 w-4 shrink-0 animate-pulse rounded bg-accent" />
                <div className="h-3.5 flex-1 animate-pulse rounded-md bg-accent" />
              </div>
            </li>
          ))}
        </ul>
      </div>
    );
  }

  return (
    <div className="py-4">
      <ul className="flex flex-col gap-3">
        {Array.from({ length: amount }, (_, i) => (
          <li key={i} className="flex items-center gap-3 px-2">
            <div className="h-10 w-10 shrink-0 animate-pulse rounded-lg bg-accent" />
            <div className="h-4 w-40 animate-pulse rounded-md bg-accent" />
            <div className="ml-auto h-3 w-20 animate-pulse rounded-md bg-secondary" />
          </li>
        ))}
      </ul>
    </div>
  );
}
